import { ShapesEnum } from 'enums';

export const templateSizes = [
  {
    id: 1,
    shape: ShapesEnum.ABSTRACT,
    label: 'Graphical Abstract',
    width: 1328,
    height: 531,
  },
  {
    id: 2,
    shape: ShapesEnum.SLIDE,
    label: 'Slides Presentation',
    width: 800,
    height: 600,
  },
  {
    id: 3,
    shape: ShapesEnum.INFOGRAPHIC,
    label: 'Infographic',
    width: 595,
    height: 842,
  },
  {
    id: 4,
    shape: ShapesEnum.POSTER,
    label: 'Poster',
    width: 711,
    height: 948,
  },
];

export function getTemplateLabelBySize(width, height) {
  const match = templateSizes.find(
    (template) => template.width === width && template.height === height,
  );

  return match ? match.label : 'Custom';
}
